(() => {
  'use strict';

  const STYLE_ID = 'pf-static-catalog-images';
  const AUTUMN_COLLECTION_PATH = '/collections/autumn-whisper';
  const AUTUMN_PRODUCTS_BY_SCENE = new Map([
    [1, { title: 'Satchel Bag', handle: 'olive-green-evening-handbag' }],
    [2, { title: 'Work Tote Bag', handle: 'olive-green-travel-tote-bag' }],
    [3, { title: 'Duffel Bag', handle: 'olive-green-weekender-duffel-bag' }],
    [4, { title: 'Tote Bag', handle: 'olive-green-designer-tote-bag' }],
    [5, { title: 'Laptop Sleeve', handle: 'olive-laptop-sleeve-bag' }]
  ]);
  let autumnClickGuardInstalled = false;

  const css = `
    html body .pickaleaf-gateway.is-catalog :is([data-catalog-view="world"], [data-catalog-view="silhouette"]) .pickaleaf-catalog__card,
    html body .pickaleaf-gateway.is-catalog :is([data-catalog-view="world"], [data-catalog-view="silhouette"]) .pickaleaf-catalog__card:hover,
    html body .pickaleaf-gateway.is-catalog :is([data-catalog-view="world"], [data-catalog-view="silhouette"]) .pickaleaf-catalog__card:focus,
    html body .pickaleaf-gateway.is-catalog :is([data-catalog-view="world"], [data-catalog-view="silhouette"]) .pickaleaf-catalog__card:focus-visible,
    html body .pickaleaf-gateway.is-catalog :is([data-catalog-view="world"], [data-catalog-view="silhouette"]) .pickaleaf-catalog__card:active,
    html body .pickaleaf-gateway.is-catalog :is([data-catalog-view="world"], [data-catalog-view="silhouette"]) .pickaleaf-catalog__card.is-visible,
    html body .pickaleaf-gateway.is-catalog :is([data-catalog-view="world"], [data-catalog-view="silhouette"]) .pickaleaf-catalog__card.pf-editorial-visible,
    html body .pickaleaf-gateway.is-catalog :is([data-catalog-view="world"], [data-catalog-view="silhouette"]) .pickaleaf-catalog__card picture,
    html body .pickaleaf-gateway.is-catalog :is([data-catalog-view="world"], [data-catalog-view="silhouette"]) .pickaleaf-catalog__card img,
    html body .pickaleaf-gateway.is-catalog :is([data-catalog-view="world"], [data-catalog-view="silhouette"]) .pickaleaf-catalog__card:hover img,
    html body .pickaleaf-gateway.is-catalog :is([data-catalog-view="world"], [data-catalog-view="silhouette"]) .pickaleaf-catalog__card:focus img,
    html body .pickaleaf-gateway.is-catalog :is([data-catalog-view="world"], [data-catalog-view="silhouette"]) .pickaleaf-catalog__card:focus-visible img,
    html body .pickaleaf-gateway.is-catalog :is([data-catalog-view="world"], [data-catalog-view="silhouette"]) .pickaleaf-catalog__card:active img {
      transform: none !important;
      translate: none !important;
      scale: none !important;
      rotate: none !important;
      animation: none !important;
      animation-name: none !important;
      transition: none !important;
      will-change: auto !important;
    }

    html body .pickaleaf-gateway.is-catalog :is([data-catalog-view="world"], [data-catalog-view="silhouette"]) .pickaleaf-catalog__card-veil::after {
      display: none !important;
      content: none !important;
      animation: none !important;
      transform: none !important;
    }
  `;

  const isAutumnPage = () => window.location.pathname.replace(/\/$/, '') === AUTUMN_COLLECTION_PATH;

  const getAutumnProduct = (scene) => {
    if (!scene) return null;

    for (const [sceneNumber, product] of AUTUMN_PRODUCTS_BY_SCENE.entries()) {
      if (scene.classList.contains(`aw-scene--${sceneNumber}`)) return product;
    }

    return null;
  };

  const updateProductLink = (link, href, label) => {
    if (!link) return;
    link.setAttribute('href', href);
    link.setAttribute('aria-label', label);
    link.dataset.noTransition = '';
  };

  const ensureTitleLink = (scene, titleHeading, product, href, label) => {
    if (!titleHeading) return null;

    let titleLink = titleHeading.querySelector('.aw-scene__title-link, a');
    if (!titleLink) {
      titleLink = document.createElement('a');
      titleLink.className = 'aw-scene__title-link';
      while (titleHeading.firstChild) titleLink.appendChild(titleHeading.firstChild);
      titleHeading.appendChild(titleLink);
    }

    titleLink.textContent = product.title;
    updateProductLink(titleLink, href, label);
    return titleLink;
  };

  const ensureVisualLink = (scene, href, label) => {
    let visualLink = scene.querySelector('.aw-scene__visual-link');
    if (!visualLink) {
      visualLink = document.createElement('a');
      visualLink.className = 'aw-scene__visual-link';
      const veil = scene.querySelector('.aw-scene__veil');
      if (veil) scene.insertBefore(visualLink, veil.nextSibling);
      else scene.prepend(visualLink);
    }

    updateProductLink(visualLink, href, label);
    return visualLink;
  };

  const installAutumnProductMapping = (scope = document) => {
    if (!isAutumnPage()) return;

    scope.querySelectorAll('.aw-scene__signature').forEach((signature) => signature.remove());

    scope.querySelectorAll('.aw-scene').forEach((scene) => {
      const product = getAutumnProduct(scene);
      if (!product) return;

      const href = `/products/${product.handle}`;
      const label = `View ${product.title}`;
      const titleHeading = scene.querySelector('.aw-scene__title-row h2');
      const cta = scene.querySelector('.aw-scene__link');

      ensureTitleLink(scene, titleHeading, product, href, label);
      updateProductLink(cta, href, label);
      ensureVisualLink(scene, href, label);

      scene.dataset.autumnProductHandle = product.handle;
    });
  };

  const containsPoint = (element, x, y) => {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    return (
      rect.width > 0 &&
      rect.height > 0 &&
      x >= rect.left &&
      x <= rect.right &&
      y >= rect.top &&
      y <= rect.bottom
    );
  };

  const findAutumnControlSceneAtPoint = (x, y) => {
    if (!Number.isFinite(x) || !Number.isFinite(y)) return null;

    const matches = [];
    document.querySelectorAll('.aw-scene').forEach((scene) => {
      const cta = scene.querySelector('.aw-scene__link');
      const title = scene.querySelector('.aw-scene__title-link');

      if (containsPoint(cta, x, y)) {
        const rect = cta.getBoundingClientRect();
        matches.push({ scene, priority: 0, area: rect.width * rect.height });
      }

      if (containsPoint(title, x, y)) {
        const rect = title.getBoundingClientRect();
        matches.push({ scene, priority: 1, area: rect.width * rect.height });
      }
    });

    matches.sort((a, b) => a.priority - b.priority || a.area - b.area);
    return matches[0]?.scene || null;
  };

  const installAutumnClickGuard = () => {
    if (!isAutumnPage() || autumnClickGuardInstalled) return;
    autumnClickGuardInstalled = true;

    document.addEventListener('click', (event) => {
      const clickedLink = event.target.closest?.(
        '.aw-scene__link, .aw-scene__title-link, .aw-scene__visual-link'
      );
      if (!clickedLink) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (clickedLink.target === '_blank' || clickedLink.hasAttribute('download')) return;

      let scene = null;
      if (event.detail !== 0) {
        scene = findAutumnControlSceneAtPoint(event.clientX, event.clientY);
      }
      if (!scene) scene = clickedLink.closest('.aw-scene');

      const product = getAutumnProduct(scene);
      if (!product) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(`/products/${product.handle}`);
    }, true);
  };

  const install = (scope = document) => {
    let style = document.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      document.head.appendChild(style);
    }

    style.textContent = css;
    installAutumnProductMapping(scope);
    installAutumnClickGuard();
  };

  install();
  document.addEventListener('DOMContentLoaded', () => install(document), { once: true });
  document.addEventListener('shopify:section:load', (event) => install(event.target || document));
})();
